package com.advaita.cloud.drive.shared

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.Serializable

/**
 * Backend-rendered runtime config the frontend needs but the server knows.
 * `storageBackend` ("local-fs" | "s3") lets the orchestrator pick the upload
 * path: presigned for S3, POST /api/files for local-fs.
 */
@Serializable
data class AuthConfigDto(
    /** az2's sign-out page, `<authorize base>/logout?redirect_uri=<DataHub>/ui/`. Sign out sends
     *  the whole tab here (ADV-1411). az2's Sign Out then lands on its own `/login?logout`, and
     *  `redirect_uri` only names DataHub on the confirm page. */
    val az2LogoutUrl: String,
    val storageBackend: String,
    /** Modular Pull master flag (drive.pull.enabled). Gates the "Pull from URL"
     *  action in the SPA. Default false keeps older clients/tests compiling;
     *  @EncodeDefault forces it onto the wire even when false (kotlinx omits
     *  default-valued fields otherwise), so the SPA always sees an explicit flag. */
    @EncodeDefault(EncodeDefault.Mode.ALWAYS)
    val pullEnabled: Boolean = false,
    /** S3 pull sub-flag (drive.pull.s3-enabled). Gates the AWS-keys credential panel in the
     *  Pull-from-URL modal: when false the SPA must NOT present the keys panel for an s3:// URL
     *  (it shows a "not enabled" notice and blocks submit). The server also rejects s3:// at
     *  admission when off, so this is purely so the panel never appears for a disabled connector.
     *  @EncodeDefault ALWAYS for the same reason as [pullEnabled] — an explicit flag on the wire. */
    @EncodeDefault(EncodeDefault.Mode.ALWAYS)
    val s3PullEnabled: Boolean = false,
    /** Archive/unarchive master flag (drive.archive.enabled). Gates the Compress
     *  action bar and the per-row Extract action in the SPA. @EncodeDefault for the
     *  same reason as pullEnabled — the SPA always sees an explicit flag. */
    @EncodeDefault(EncodeDefault.Mode.ALWAYS)
    val archiveEnabled: Boolean = false,
)
